export default __webpack_public_path__ + "static/media/burger.b19e17cf.svg";